import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/api";
import { BASE_API_URL } from "@/api/api";
import type { HotelSearchTokens } from "@/features/hotels/types/types";
import type { CheckHotelsSearchProgressOutputDto } from "@/types/codegen";

export const useHotelSearchProgress = (tokens: HotelSearchTokens | null) => {
  const query = useQuery({
    queryKey: ["hotels", "search", "progress", tokens] as const,
    queryFn: ({ signal }) =>
      api.get<CheckHotelsSearchProgressOutputDto>(
        `${BASE_API_URL}/hotels/search/progress`,
        {
          params: tokens,
          signal,
        },
      ),
    select: (response) => response.data,
    enabled: Boolean(tokens),
    refetchInterval: (query) => {
      if (query.state.data?.data.data.status === "COMPLETED") {
        return false;
      }

      return 250;
    },
  });

  return query;
};
